/**
 * Post loading and pagination functionality
 * @module posts
 */

const SELECTORS = {
  container: '.wp-block-query--main .wp-block-post-template',
  loadMore: '.wp-block-query--main .wp-block-query-pagination > a',
  postItem: '.wp-block-query--main .wp-block-post'
};

/**
 * Initializes post loading functionality
 */
export function initializePostLoading() {
  document.querySelectorAll(SELECTORS.loadMore)
          .forEach(btn => btn.addEventListener('click', handleLoadMore));
}

async function handleLoadMore(e) {
  e.preventDefault();
  const btn = e.target;
  btn.classList.add('is-loading');
  btn.disabled = true;

  try {
    const doc = await fetchAndParse(btn.href);
    await appendNewPosts(doc, btn);
  } catch (error) {
    console.error('Error loading posts:', error);
    resetButton(btn);
  }
}

async function fetchAndParse(url) {
  const response = await fetch(url);
  const html = await response.text();
  return new DOMParser().parseFromString(html, 'text/html');
}

async function appendNewPosts(doc, btn) {
  const container = document.querySelector(SELECTORS.container);
  const newItems = doc.querySelectorAll(SELECTORS.postItem);
  const newLoader = doc.querySelector(SELECTORS.loadMore);

  newItems.forEach(item => container.appendChild(item.cloneNode(true)));

  if (newLoader) {
    btn.href = newLoader.href;
    resetButton(btn);
  } else {
    setTimeout(() => btn.parentElement.remove(), 500);
  }

  // Reinitialize Cloudflare Mirage
  if (window.Mirage && typeof window.Mirage.reinitialize === 'function') {
    window.Mirage.reinitialize();
  }

  container.dispatchEvent(new Event('change'));
}

function resetButton(btn) {
  btn.classList.remove('is-loading');
  btn.disabled = false;
}
